/**
 * A getter for a reactive value that no effect can depend on. Reading `source` inside an effect
 * (urql-vue's subscribe effect, say) makes every change to it re-run that effect; this keeps a
 * plain copy instead, updated by a sync watch, so callers see the current value without
 * subscribing to it. With `live` off (the server, where the value never changes during a
 * request) the copy is taken once.
 */
export const createUntrackedMirror = <T>(source: () => T, live: boolean = true): (() => T) => {
  let current = source();
  if (live) {
    watch(source, (value) => {
      current = value;
    }, { flush: 'sync' });
  }
  return () => current;
};
